import { isFunction } from '@isyscore/utils/type';
import { USER_TOKEN_REQ_ORDER } from '../../order-define';
export const reqUserToken = (options) => {
    const { headerKey = 'token', tokenVal = '' } = options || {};
    const getTokenVal = isFunction(tokenVal) ? tokenVal : () => tokenVal;
    return {
        reqOrder: USER_TOKEN_REQ_ORDER,
        reqInterceptor(req) {
            if (headerKey && !req.headers[headerKey])
                req.headers[headerKey] = getTokenVal();
            return req;
        }
    };
};
